"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../../app-reduxs/app/slice"));
const IconLike_1 = __importDefault(require("../../../../assets/icons/IconLike"));
const IconLiked_1 = __importDefault(require("../../../../assets/icons/IconLiked"));
const CustomText_1 = __importDefault(require("../../../../components/text/CustomText"));
const Article_1 = __importDefault(require("../../../../networking/apis/Article"));
const scale_1 = require("../../../../utils/scale");
const LikeButton = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { commentId, defaultLiked, defaultLikes, disabled = false } = props;
    const [likes, setLikes] = (0, react_1.useState)(defaultLikes);
    const [isLiked, setLiked] = (0, react_1.useState)(defaultLiked);
    const refIsCallingApi = (0, react_1.useRef)(false);
    const dataUser = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile, react_redux_1.shallowEqual);
    const toggleLikeButton = () => {
        if (dataUser?.registration_status == 0) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        if (refIsCallingApi.current)
            return;
        refIsCallingApi.current = true;
        (isLiked ?
            Article_1.default.unlikeArticleComment(commentId)
            :
                Article_1.default.likeArticleComment(commentId))
            .then((_) => {
            setLikes(isLiked ? likes - 1 : likes + 1);
            setLiked(!isLiked);
        })
            .catch((_) => { })
            .finally(() => refIsCallingApi.current = false);
    };
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles.button, onPress: toggleLikeButton, disabled: disabled },
        isLiked ? react_1.default.createElement(IconLiked_1.default, null) : react_1.default.createElement(IconLike_1.default, { color: '#545454' }),
        react_1.default.createElement(CustomText_1.default, { weight: "300", style: [styles.label, { color: isLiked ? '#44A06B' : '#545454' }] }, likes)));
};
exports.default = LikeButton;
const styles = react_native_1.StyleSheet.create({
    button: {
        flexDirection: "row",
        marginLeft: (0, scale_1.scale)(24),
        alignItems: "center",
    },
    label: {
        fontSize: (0, scale_1.moderateScale)(12),
        lineHeight: (0, scale_1.moderateScale)(18),
        marginLeft: (0, scale_1.scale)(8),
        marginRight: (0, scale_1.scale)(24),
    }
});
